import _ from 'lodash';
import {useState} from 'react';

/**
 * Returns `value` while `isReady` is true, and the last value seen while ready
 * (or `initial`, before the first ready render) otherwise.
 */
export function useLastWhen<T>(value: T, isReady: boolean, initial: T): T {
  const [lastReady, setLastReady] = useState<T>(initial);
  if (isReady && !_.isEqual(value, lastReady)) {
    setLastReady(value);
  }
  return isReady ? value : lastReady;
}
